'use client';

import { useCurrentURL } from '@hooks/useCurrentURL';
import { flowsURLParameters, URLParameters } from '../../../../../views/Authentication/constants';
import {
  IInternalLinkProps,
  NonCrawlableLink,
} from '../../../../Clickables/NonCrawlableLink/NonCrawlableLink';

export const LoginButton = ({
  onClick,
  buttonSize,
  className,
  testId,
}: {
  onClick: () => void;
  buttonSize: IInternalLinkProps['size'];
  className?: string;
  testId?: string;
}) => {
  const { addParameters } = useCurrentURL();
  const loginLink = addParameters({ [URLParameters.Flow]: flowsURLParameters.login });
  return (
    <NonCrawlableLink
      variant="buttonSecondary"
      size={buttonSize}
      className={className}
      routerPushTo={loginLink}
      onClickEvent={onClick}
      ariaLabel="log in to Fishbrain"
      testId={testId}
    >
      Log in
    </NonCrawlableLink>
  );
};
